/*
  Based on: https://cookieconsent.insites.com/documentation/javascript-api/
*/

const cookieconsent = require('./cookieconsent.js');

var getQueryString = function ( field, url ) {
  var href = url ? url : window.location.href;
  var reg = new RegExp( '[?&]' + field + '=([^&#]*)', 'i' );
  var string = reg.exec(href);
  return string ? string[1] : null;
};
var setCookie = function (cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires="+d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
};
var getCookie = function (cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for(var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
};

//var myDomain = "vps.no";
//test set to undefined
var myDomain = ".vps.no";

var cookieSettings = {
  name: "vpscookiealert_status",
  path: "/",
  domain: myDomain,
  expiryDays: 3600
};

//Set language and others
var defaultContentTexts = {
  message: "This website uses cookies. Read more: ",
  messageALT: "Dette nettstedet bruker cookies. Les mer: ",
  dismiss: "OK",
  link: "Cookie policy",
  link2: "Privacy policy",
  linkALT: "Cookie-policy",
  linkALT2: "Personvernerkl&aelig;ring",
  href: 'https://www.vps.no/pub/about-us/cookie-policy/?lang=en',
  href2: 'https://www.vps.no/pub/about-us/privacy-policy/?lang=en',
  hrefALT: 'https://www.vps.no/pub/om-oss/cookie-policy/',
  hrefALT2: 'https://www.vps.no/pub/om-oss/personvernerklaering/',
};

window.addEventListener("load", function(){
window.cookieconsent.initialise({
  "palette": {
    "popup": {
      "background": "#222222",
      "text": "#ffffff"
    },
    "button": {
      "background": "#0b7bbd",
      "text": "#ffffff"
    }
  },
  "content": defaultContentTexts,
  "cookie": cookieSettings
})});



// WEBPACK FOOTER //
// ./src/index.js